/**
 * FAQ Service - API client for the knowledge-base / FAQ articles.
 * Non-admin/HR users only ever see published articles (backend filters
 * this automatically); admin/HR (super_admin, school_admin, hr) see
 * everything including unpublished drafts.
 */
import api from '../utils/api';

const faqService = {
  list: async (category = null) => {
    try {
      const params = {};
      if (category) params.category = category;
      return await api.get('/api/faq', { params });
    } catch (error) {
      console.error('Error fetching FAQ articles:', error);
      throw error;
    }
  },

  listCategories: async () => {
    try {
      return await api.get('/api/faq/categories');
    } catch (error) {
      console.error('Error fetching FAQ categories:', error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      return await api.post('/api/faq', data);
    } catch (error) {
      console.error('Error creating FAQ article:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      return await api.patch(`/api/faq/${id}`, data);
    } catch (error) {
      console.error('Error updating FAQ article:', error);
      throw error;
    }
  },

  remove: async (id) => {
    try {
      return await api.delete(`/api/faq/${id}`);
    } catch (error) {
      console.error('Error deleting FAQ article:', error);
      throw error;
    }
  },

  recordView: async (id) => {
    try {
      return await api.post(`/api/faq/${id}/view`, {});
    } catch (error) {
      console.error('Error recording FAQ view:', error);
      throw error;
    }
  },
};

export default faqService;
